export default __webpack_public_path__ + "static/media/about_border.15b31816.jpg";